/* eslint-disable prettier/prettier */
import React from "react";

const Phone = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5542 6.24003L7.17123 2.33503C6.78123 1.88503 6.06623 1.88703 5.61323 2.34103L2.83123 5.12803C2.00323 5.95703 1.76623 7.18803 2.24523 8.17503C5.10685 14.1 9.88528 18.8851 15.8062 21.755C16.7922 22.234 18.0222 21.997 18.8502 21.168L21.6582 18.355C22.1132 17.9 22.1142 17.181 21.6602 16.791L17.7402 13.426C17.3302 13.074 16.6932 13.12 16.2822 13.532L14.9182 14.898C14.8484 14.9712 14.7565 15.0195 14.6566 15.0354C14.5567 15.0513 14.4543 15.0339 14.3652 14.986C12.1357 13.7021 10.2862 11.8503 9.00523 9.61903C8.95726 9.52978 8.93989 9.42726 8.95578 9.32719C8.97168 9.22711 9.01996 9.13502 9.09323 9.06503L10.4532 7.70403C10.8652 7.29003 10.9102 6.65003 10.5542 6.23903V6.24003Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Phone;
